import { render, staticRenderFns } from "./JumpingResultComponent.vue?vue&type=template&id=508ec2b5&scoped=true"
import script from "./JumpingResultComponent.vue?vue&type=script&lang=ts"
export * from "./JumpingResultComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ec2b5",
  null
  
)

export default component.exports